import {useTranslation} from '@aboutyou/i18n';
import {CategoryTile, UnstyledLinkLinaria} from '@aboutyou/ui-components';
import React from 'react';

export const AllDealsTile = ({
  color,
  linkTarget,
}: {
  color: string;
  linkTarget: string;
}) => {
  const {t} = useTranslation();
  return (
    <li tabIndex={-1}>
      <UnstyledLinkLinaria
        data-testid="categoryTreeNavigationItem_AllDeals"
        to={linkTarget}
        aria-label={undefined}
      >
        <CategoryTile
          backgroundColor={color}
          label={t('All Deal Items')}
          labelColor="Text.White"
        />
      </UnstyledLinkLinaria>
    </li>
  );
};
